import { Injectable } from "@angular/core";
import {
	debounceTime,
	fromEvent,
	merge,
	repeat,
	Subject,
	switchMap,
	takeUntil,
	timer,
} from "rxjs";

@Injectable({
	providedIn: "root",
})
export class SessionService {
	private readonly idleTime = 1000 * 60 * 13; //13 minutes
	private readonly timeoutTime = 1000 * 60 * 2; //2 minutes
	private readonly idleTimeEventSubject = new Subject<void>();
	private readonly timeoutEventSubject = new Subject<void>();
	private readonly stopIdleTimeTimer = new Subject<void>();
	private readonly startIdleTimeTimer = new Subject<void>();
	private readonly startTimeoutTimer = new Subject<void>();
	private readonly stopTimeoutTimer = new Subject<void>();
	public readonly idleTimeEvent$ = this.idleTimeEventSubject.asObservable();
	public readonly timeoutEvent$ = this.timeoutEventSubject.asObservable();

	public startSession() {
		this.startTimeoutTimer
			.pipe(
				switchMap(() =>
					timer(this.timeoutTime, this.timeoutTime).pipe(
						takeUntil(this.stopTimeoutTimer),
					),
				),
			)
			.subscribe({
				next: () => {
					this.timeoutEventSubject.next();
					this.stopTimeoutTimer.next();
				},
				error: (err) => console.error("Timer error:", err),
			});

		timer(this.idleTime, this.idleTime)
			.pipe(
				takeUntil(this.stopIdleTimeTimer),
				repeat({ delay: () => this.startIdleTimeTimer }),
			)
			.subscribe({
				next: () => {
					this.idleTimeEventSubject.next();
					this.stopIdleTimeTimer.next();
					this.startTimeoutTimer.next();
				},
				error: (err) => console.error("Timer error:", err),
			});

		const mouseMove$ = fromEvent<MouseEvent>(document, "keydown");
		const keyPress$ = fromEvent<KeyboardEvent>(document, "click");
		merge(mouseMove$, keyPress$)
			.pipe(
				debounceTime(1000),
				takeUntil(this.stopIdleTimeTimer),
				repeat({ delay: () => this.startIdleTimeTimer }),
			)
			.subscribe({
				next: () => {
					this.stopIdleTimeTimer.next();
					this.startIdleTimeTimer.next();
				},
				error: (err) => {
					console.error("Event listener error:", err);
				},
			});
	}

	public extendSession() {
		this.stopTimeoutTimer.next();
		this.stopIdleTimeTimer.next();
		this.startIdleTimeTimer.next();
	}
}
